export default "__VITE_ASSET__BsLfhG_A__"